import React from 'react';
import { __ } from '../../../../utils/translation-service';

export const FooterStickyMobile = () => {
    return (
        <div id="stickyFooterA" className="stickyFooter visible-xs">
            <ul className="list-inline">
                <li className="col-xs-6 text-center">
                    <a
                        id="callButtonOld"
                        href={`tel:<r hidden>phonelead</r>`}
                        title={__('callYourCruiseConsultant')}
                    >
                        <span className="pull-left icon-handset visible-xs-inline" />
                        <div>&nbsp; {__('callUs')}</div>
                    </a>
                </li>

                <li className="col-xs-6 text-center">
                    <a
                        id="emailButtonOld"
                        href={`mailto:${__('infoEmail')}`}
                        title={__('sendMail')}
                    >
                        <span className="pull-left icon-email visible-xs-inline" />
                        <div>&nbsp;{__('sendMail')}</div>
                    </a>
                </li>
            </ul>
        </div>
    );
};
